<template>
  <div class="dashboard">
      <v-content class="pa-10">
          <v-row>

            <v-col cols="6" md="3" sm="6" v-for="item in items" :key="item.label">
              <v-card :to="item.route" hover :color="item.color" dark>
                <v-card-title>{{ item.label }} </v-card-title>
                <v-card-text>
                  <div class="subtitle">
                    Total Records: 
                    <v-progress-circular v-if="isLoading" :size="25" :width="2" indeterminate color="white pl-3"></v-progress-circular>
                    <span v-if="!isLoading" class="bold title">{{ item.size }}</span></div>
                </v-card-text>
              </v-card>
            </v-col>

          </v-row>
      </v-content>
  </div>
</template>

<script>
import { db, auth } from '@/plugins/appfirebase'
export default {

  created() {
    for ( let i = 0 ; i < this.items.length ; i++ ) {
      this.getSize(this.items[i].val, i);
    }
  },

  data() {
    return {
      items: [
        { label: 'E-Mail', val: 'email', route: 'admin/accounts/email', color: 'brown', size: 0},
        { label: 'Facebook', val: 'facebook', route: 'admin/accounts/facebook', color: 'blue', size: 0 },
        { label: 'Godaddy', val: 'godaddy', route: 'admin/accounts/godaddy', color: 'green', size: 0 },
        { label: 'Paypal', val: 'paypal', route: 'admin/accounts/paypal', color: 'purple', size: 0 },
        { label: 'Virtual Card', val: 'vcard', route: 'admin/accounts/virtualcard', color: 'light', size: 0 },
        { label: 'Website', val: 'website', route: 'admin/accounts/website', color: 'indigo', size: 0 },
        { label: 'Apple', val: 'apple', route: 'admin/accounts/apple', color: 'grey', size: 0 },
      ],
      isLoading: true
    }
  },

  methods: {
    getSize(col, key) {
      db.collection(col).doc(auth.currentUser.uid).collection('data').get()
        .then( docs => { this.items[key].size = docs.size; this.isLoading = false })
    },
  }

}
</script>

<style>

</style>